import React from "react";
import MobilePopup from '../../shared/MobilePopup/MobilePopup';
import Cookies from 'js-cookie';
import { PuzzleNames } from '../../../../utils/types';
import { DOMAIN } from '../../shared/utils';
import { isMobile, isTablet } from 'react-device-detect';
import InstructionsVideo_mp4 from 'url:./videos/Rubigram.mp4';
import InstructionsVideo_webm from 'url:./videos/Rubigram.webm';
import { RubigramStore } from '../RubigramStore';

const MobileRubigramInstructions = () => {
  const isOpen = RubigramStore.useState(s => s.instructionsAreOpen);
  const isTouch = isMobile || isTablet;

  const onClose = () => {
    Cookies.set(`${PuzzleNames.Rubigram}InstructionsDismissed`, 'true', {
      domain: DOMAIN,
      expires: 365,
    });
    RubigramStore.update(s => {
      s.instructionsAreOpen = false;
      s.isSoftPaused = false;
    });
  };

  return (
    <MobilePopup isOpen={isOpen} onClose={onClose} title="How to Play the Rubigram">
      <ul>
        <li>Rotate and flip until every full row and column spells a 6-letter word from left-to-right and top-to-bottom.</li>
        <li>Flip the 3x3 subgrids by {isTouch ? 'tapping' : 'clicking'} their non-corner cells.</li>
        {!isTouch && <li>Right-click the rotate buttons to rotate counterclockwise.</li>}
        <li>No very obscure words or proper names.</li>
      </ul>

      <video controls autoPlay>
        <source src={InstructionsVideo_webm} type="video/webm" />
        <source src={InstructionsVideo_mp4} type="video/mp4" />
        <p>Your browser does not support HTML5 video elements.</p>
      </video>
    </MobilePopup>
  );
};

export default MobileRubigramInstructions;